import { FilterColumn, PendStatuses } from "types";

const loadOptions = () => ({
	options: PendStatuses.getOptions({
		predicate: item => item.name !== "closed",
	}),
	hasMore: false,
});

const pendStatusColumn = (): FilterColumn => ({
	name: "pendStatus",
	type: "select" as const,
	loadOptions,
	getOptionLabel: option => option.displayName,
	getOptionValue: option => option.value,
	placeholder: "Pend Status",
});

export default pendStatusColumn;
